import React from 'react'
import Filtro from '../comum/Filtro'
import FiltrosAdicionadosAgendamentoViagem from './FiltrosAdicionadosAgendamentoViagem'
import PainelFiltragem from '../comum/PainelFiltragem'
import FiltroAgendamentoViagem from './FiltroAgendamentoViagem';

export const PainelFiltroAgendamento = () => (
  <Filtro PainelFiltro={FiltroAgendamentoViagem}/>
);

const PainelFiltrosAgendamentoViagem = () => (
  <PainelFiltragem
    Filtro={PainelFiltroAgendamento}
    FiltrosAdicionados={FiltrosAdicionadosAgendamentoViagem}/>
)

export default PainelFiltrosAgendamentoViagem
